import React from 'react';
import { Box, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';
import { Select } from '@atlassian/help-center-common-component/analytics/select';
import type { Option } from '../../../types';

export const OptionDropdown = ({
    options,
    onSelectOption,
}: {
    options: Option[];
    onSelectOption: (selectedOption: Option) => void;
}) => {
    return (
        <Box xcss={selectWrapper} testId="virtual-agent-conversation-option-dropdown">
            <Select
                classNamePrefix="virtual-agent-conversation-option-dropdown"
                actionSubjectId="virtualAgentConversationOption"
                options={options}
                getOptionLabel={(option: Option) => option.label}
                getOptionValue={(option: Option) => option.id}
                onChange={onSelectOption}
                menuPlacement="top"
            />
        </Box>
    );
};

const selectWrapper = xcss({
    flexGrow: '1',
    minWidth: 'size.1000',
    marginRight: token('space.100', '8px'),
});
